import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Row, Col, Layout, Icon } from 'antd';
import TopNav from '../../components/topnav/topnav';
import Footer from '../../components/footer/footer';
import SignupflowForm from '../../components/signup/signupflowform';
import ReactGA from 'react-ga';
import Billing from '../stripe/billing';
import { bindActionCreators } from "redux"
import { proPlanPrice, basicPlanPrice } from "../../../../../config/fbConfig"
import { signUp, getPaymentToken, signUpFlow } from './../../../../core/actions/auth';
import { message } from 'antd';
import { Helmet } from "react-helmet";
const { Content } = Layout;

class SignupFlow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      toggleAction: false,
      currentPlan: {},
      switchbuttons: [
        { id: 1, active: false, title: 'PAY MONTHLY', plan: 'monthly' },
        { id: 2, active: false, title: 'PAY YEARLY', plan: 'yearly' }
      ],
      token: '',
      preload: true
    };
  }

  toggleModal = () => this.setState({
    toggleAction: !this.state.toggleAction
  })

  initializePlan = (plan) => {
    var plans = [
      { id: 2, title: 'basic', package: "Monthly", price: basicPlanPrice, users: 8, storage: 5 },
      { id: 3, title: 'pro', package: "Yearly", price: proPlanPrice, users: 12, storage: 7 }
    ]
    this.state.switchbuttons.map((btn) => btn.active = false)
    this.state.switchbuttons.filter((btnn) => {
      if (plan === btnn.plan) {
        btnn.active = true
      }
    })
    var pricingPlans = plans.filter((pplan) => (plan === pplan.package.toLowerCase()))
    let newPlan = pricingPlans[0]
    this.setState({
      currentPlan: newPlan
    })
  }

  componentWillMount() {
    if (window.location.search) {
      let query = window.location.search
      let URL = new URLSearchParams(query);
      let urlPlan = URL.get("plan")
      this.initializePlan(urlPlan)
    } else this.initializePlan('monthly')
  }

  componentWillReceiveProps(nextProps) {
    const { authError, authSuccess, profile } = nextProps;
    if (authError) message.error(authError);
    if (!nextProps.loading && nextProps.auth.uid && nextProps.authSuccess) {
      // if (authSuccess) message.success(authSuccess);
      // localStorage.setItem('role', profile.role);
      window.fbq('track', 'CompleteRegistration');
      ReactGA.event({
        category: 'User',
        action: 'Complete Registration',
        label: 'User Interaction'
      });
    }
  }

  componentDidMount() {
   setTimeout(() => {
     this.setState({
       preload: false
     })
   }, 300);
  }

  render() {
    const { toggleAction, stepOne, currentPlan, switchbuttons, preload } = this.state
    return (
      !preload ? <div className="subscription-page">
        <Helmet>
          <title>Pricing plan </title>
          <meta name="description" content="Pay for what you need!" />
        </Helmet>
        <TopNav history={this.props.history} toggleAction={toggleAction} toggleModal={this.toggleModal} />
        {/* <section className="xheader">
           <Row>
               <Col sm={24} lg={6} ></Col>
               <Col sm={24} lg={12}>
               <h1 >  Enroll into Orsity </h1>
             <p>Ready to get started? learn something new today</p>
               </Col>
               <Col sm={24} lg={6} ></Col>
           </Row>
       </section> */}
        <Content className="signupflow">

          <div className="signupflow-content">
            <Row>
              <Col
                lg={{ span: 22, offset: 1 }}>
                <Row gutter={32}>
                  <Col lg={8} md={9} className="plan-summary">
                    <div className="switch">
                      {
                        switchbuttons.map((btn) => (
                          <span className={`buttons ${btn.active ? 'active' : ''}`} onClick={() => this.initializePlan(btn.plan)} key={btn.id}>
                            {btn.title}
                          </span>
                        ))
                      }
                    </div>
                    {/* <div className="switch">
                     <span className="buttons active"  onClick={()=>this.initializePlan('monthly')}>
                       PAY MONTHLY
                     </span>
                     <span className="buttons" onClick={()=>this.initializePlan('yearly')}>
                       PAY YEARLY
                     </span>
                   </div> */}
                    <div className={`plan-card ${currentPlan.package.toLowerCase() == 'yearly' ? 'yearly' : ''}`}>
                      <p className="plan-title">{currentPlan.package} PLAN</p>
                      <p className="notice">
                        Ready to get Started? Learn something new today
                     </p>
                      <p className="starting-at">Starting at</p>
                      <div className="plan-pricing">
                        <span className="currency">$</span>
                        <h1 className="price">{currentPlan.price}</h1>
                        <span className="plan-type">
                          /{currentPlan.package}
                        </span>
                      </div>
                    </div>
                    <div className="price-summary">
                      <h5>Order summary</h5>
                      <div className="order-desc">
                        <p className="desc">
                          <span>{currentPlan.package} Subscription</span>
                          <span>${currentPlan.price}</span>
                        </p>
                        <p className="desc total">
                          <span>Total</span>
                          <span>${currentPlan.price}</span>
                        </p>
                      </div>
                    </div>
                  </Col>
                  {!this.props.auth.uid ?
                    <Col lg={16} md={15} className="user-details">
                      <div className="top">
                        <div className="top-header">
                          <h5 className="info">General Information</h5>
                          <span className="steps">Step 1 of 2</span>
                        </div>
                        <p style={{ marginTop: "10px" }}>Your email will be used for creating your Orsity account. Or <span className="signin" onClick={this.toggleModal}>Sign in</span> </p>
                        <SignupflowForm
                          loading={this.props.loading}
                          signUp={this.props.signUp}
                          profile={this.props.profile}
                          auth={this.props.auth}
                          authError={this.props.authError}
                          authSuccess={this.props.authSuccess}
                        />
                      </div>
                    </Col> :
                    <Col lg={16} md={15} className="user-details">
                      <div className="top">
                        <div className="top-header">
                          <h5 className="info">Billing Information</h5>
                          <span className="steps">Step 2 of 2</span>
                        </div>
                        <p style={{ marginTop: "10px" }}>Fill in your correct card billing information to activate a purchase.</p>
                        <Billing

                          plan={this.state.currentPlan}
                          paymentTokenID={this.props.paymentTokenID}
                          history={this.props.history}
                          profile={this.props.profile}
                          signUpFlow={this.props.signUpFlow}
                          getPaymentToken={this.props.getPaymentToken}
                        />
                      </div>
                    </Col>
                  }
                </Row>
              </Col>
            </Row>
          </div>
        </Content>
        <Footer />
      </div> : <div className="x-loader">
          <Icon type="loading" style={{ fontSize: 60 }} spin />
        </div>
    )
  }
}

const mapStateToProps = state => ({
  auth: state.firebase.auth,
  profile: state.firebase.profile,
  loading: state.auth.loading,
  authError: state.auth.authError,
  authSuccess: state.auth.authSuccess,
  paymentTokenID: state.auth.paymentTokenID,
  paymentToken: state.auth.paymentToken
});

const mapDispatchToProps = dispatch => bindActionCreators({
  signUp,
  getPaymentToken,
  signUpFlow
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignupFlow);